import { useEffect, useMemo, useState } from 'react';
import { Activity, Search } from 'lucide-react';
import { Navigate } from 'react-router-dom';
import { EmptyState, Notice, PageLoader, formatTimestamp } from '../components/UI';
import { useAuth } from '../context/AuthContext';
import { subscribeToCollection } from '../services/data';

export default function AuditLogsPage() {
  const { isSuperAdmin, can } = useAuth();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isSuperAdmin && !can('auditLogs', 'view')) return undefined;
    return subscribeToCollection('auditLogs', (records) => {
      setLogs(records.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0)));
      setLoading(false);
    }, (snapshotError) => { setError(snapshotError.message); setLoading(false); });
  }, [can, isSuperAdmin]);

  const filtered = useMemo(() => logs.filter((log) => JSON.stringify(log).toLowerCase().includes(search.toLowerCase())), [logs, search]);
  if (!isSuperAdmin && !can('auditLogs', 'view')) return <Navigate to="/unauthorized" replace />;

  return (
    <div className="page-stack">
      <header className="page-heading"><div><p className="eyebrow">Security history</p><h1>Audit Logs</h1><p>Portal data par thayela create, update ane delete changes.</p></div><span className="heading-icon"><Activity size={23} /></span></header>
      {error ? <Notice type="error">{error}</Notice> : null}
      <section className="panel-card table-panel"><div className="table-toolbar"><label className="search-box"><Search size={18} /><input value={search} placeholder="Search collection, admin or action…" onChange={(event) => setSearch(event.target.value)} /></label></div>
        {loading ? <PageLoader /> : filtered.length ? <div className="data-table-wrap"><table className="data-table"><thead><tr><th>Action</th><th>Record</th><th>Admin</th><th>Time</th></tr></thead><tbody>{filtered.map((log) => <tr key={log.id}><td><span className={`audit-action ${log.action}`}>{log.action}</span></td><td><div className="audit-record"><strong>{log.collection}</strong><code>{log.documentId}</code></div></td><td><div className="audit-admin"><strong>{log.actorEmail || 'System'}</strong><span>{log.actorId || log.authType || 'unknown'}</span></div></td><td className="muted-cell">{formatTimestamp(log.createdAt)}</td></tr>)}</tbody></table></div> : <EmptyState icon={Activity} title="No audit logs yet" description="Cloud Functions deploy pachhi portal changes automatically ahi record thase." />}
      </section>
    </div>
  );
}
